import * as io from 'io-ts';

export const PaymentPlan = io.type({
  headline: io.string,
  headlineDisclosureSymbol: io.string,
  subhead: io.string,
  subheadDisclosureSymbol: io.string,
});

export type PaymentPlan = io.TypeOf<typeof PaymentPlan>;

export const LoanTerms = io.type({
  subhead: io.string,
  subheadInstallmentDisclosureSymbol: io.string,
});

export type LoanTerms = io.TypeOf<typeof LoanTerms>;

export const InstallmentsDynamicDisclosure = io.type({
  installmentsDisclosureSymbol: io.string,
  installmentsDisclosureText: io.string,
});

export const SplitPayDynamicDisclosure = io.type({
  splitPayDisclosureSymbol: io.string,
  splitPayDisclosureText: io.string,
});
export const HybridLineOfCreditDisclosure = io.type({
  hybridLineOfCreditDisclosureSymbol: io.string,
  hybridLineOfCreditDisclosureText: io.string,
});

export const DynamicDisclosureFooter = io.type({
  footer: io.string,
});

export const DynamicDisclosure = io.intersection([
  InstallmentsDynamicDisclosure,
  SplitPayDynamicDisclosure,
  HybridLineOfCreditDisclosure,
  DynamicDisclosureFooter,
]);

export type DynamicDisclosure = io.TypeOf<typeof DynamicDisclosure>;
